import React from 'react';

import { useCard } from '@src/reducers/product';

import styles from '../../styles.module.scss';

export const Penalty = () => {
    const { penalty } = useCard();

    return (
        <div className={styles.cardItem}>
            <div className={styles.title}>Начисление неустойки от суммы неуплаты</div>
            <div className={styles.text}>{penalty}</div>
        </div>
    );
};
